<div fxLayout="row" fxLayoutAlign="start center">
  <h1 fxFlex mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="max-height: 30px; white-space: nowrap;
      overflow: hidden; text-overflow: ellipsis;">{{label}}</h1>
  <span class="dialog-button-span">
    <button *ngIf="HistoryFlag" class="dialog-button" mat-icon-button tabindex="-1" (click)="onHistoryClick()"
      [title]="'CONSTS.HISTORY' | translate" (mouseenter)="isBlue[0] = true" (mouseleave)="isBlue[0] = false">
      <mat-icon class="dialog-button-icon" [@blueBold]="isBlue[0] ? 'blue' : 'normal'">history</mat-icon>
    </button>
    <button *ngIf="CenterFlag" class="dialog-button" mat-icon-button tabindex="-1" (click)="onSelectedClick()"
      [title]="'CONSTS.REMOTE_HOOK_OBJECT' | translate" (mouseenter)="isBlue[1] = true"
      (mouseleave)="isBlue[1] = false">
      <mat-icon class="dialog-button-icon" [@blueBold]="isBlue[1] ? 'blue' : 'normal'">touch_app</mat-icon>
    </button>
    <button *ngIf="CenterFlag" class="dialog-button" mat-icon-button tabindex="-1" (click)="onCenterClick()"
      [title]="'CONSTS.CENTER' | translate" (mouseenter)="isBlue[2] = true" (mouseleave)="isBlue[2] = false">
      <mat-icon class="dialog-button-icon" [@blueBold]="isBlue[2] ? 'blue' : 'normal'">room</mat-icon>
    </button>
    <button *ngIf="DCenterFlag" class="dialog-button" mat-icon-button tabindex="-1" (click)="onDCenterClick()"
      [title]="'CONSTS.DYNAMIC_CENTER' | translate: {DCFlag: DCFlag ? 'On' : 'Off'}" (mouseenter)="isBlue[3] = true"
      (mouseleave)="isBlue[3] = false">
      <mat-icon class="dialog-button-icon"
        [@blueBold]="isBlue[3] ? 'blue' : 'normal'">{{DCenterIconOp[DCFlag]}}</mat-icon>
    </button>
    <button class="dialog-button" mat-icon-button tabindex="-1" (click)="onCloseBtnClick()"
      [title]="'CONSTS.CLOSE_WINDOW' | translate" (mouseenter)="isRed = true" (mouseleave)="isRed = false">
      <mat-icon class="dialog-button-icon" [@redBold]="isRed ? 'red' : 'normal'">close</mat-icon>
    </button>
  </span>
</div>